import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';

// El tipo de actor comercial del proveedor (pedido de Delicia). Clasifica cada
// jugador de la cadena para poder ver la cotización desglosada por actor.
export type FreightProviderType =
  | 'NAVIERA'
  | 'NVOCC'
  | 'AGENTE_CARGA'
  | 'TRANSPORTISTA'
  | 'AEROLINEA'
  | 'AGENCIA_ADUANERA'
  | 'ASEGURADORA'
  | 'OTRO';

export const FREIGHT_PROVIDER_TYPE_LABELS: Record<FreightProviderType, string> = {
  NAVIERA: 'Naviera',
  NVOCC: 'NVOCC',
  AGENTE_CARGA: 'Agente de carga',
  TRANSPORTISTA: 'Transportista',
  AEROLINEA: 'Aerolínea',
  AGENCIA_ADUANERA: 'Agencia aduanera',
  ASEGURADORA: 'Aseguradora',
  OTRO: 'Otro',
};

// Campos extendidos del proveedor — fiscales, contacto, bancarios, operativos.
export interface FreightProviderExtra {
  /** Tipo de actor: naviera, NVOCC, aduana, seguro, … Ver FREIGHT_PROVIDER_TYPE_LABELS. */
  providerType?: FreightProviderType | null;
  sapCode?: string | null;
  // Fiscal
  taxId?: string | null;
  legalName?: string | null;
  fiscalAddress?: string | null;
  // Contacto
  email?: string | null;
  phone?: string | null;
  whatsapp?: string | null;
  contactName?: string | null;
  website?: string | null;
  // Banco
  bankName?: string | null;
  accountNumber?: string | null;
  accountType?: string | null;
  beneficiaryName?: string | null;
  swiftCode?: string | null;
  // Operativos
  countryCode?: string | null;
  serviceArea?: string | null;
  creditTermsDays?: number | null;
  rating?: number | null;
  notes?: string | null;
}

export interface FreightProvider extends FreightProviderExtra {
  id: string;
  name: string;
  transportModes: string[];
  contactInfo: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFreightProviderData extends FreightProviderExtra {
  name: string;
  transportModes: string[];
  contactInfo?: string | null;
}

export interface UpdateFreightProviderData extends FreightProviderExtra {
  name?: string;
  transportModes?: string[];
  contactInfo?: string | null;
  isActive?: boolean;
}

class FreightProviderService {
  async getAll(): Promise<FreightProvider[]> {
    return apiClient.get(ENDPOINTS.FREIGHT_PROVIDERS);
  }

  async create(data: CreateFreightProviderData): Promise<FreightProvider> {
    return apiClient.post(ENDPOINTS.FREIGHT_PROVIDERS, data);
  }

  async update(id: string, data: UpdateFreightProviderData): Promise<FreightProvider> {
    return apiClient.put(ENDPOINTS.FREIGHT_PROVIDER_BY_ID(id), data);
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(ENDPOINTS.FREIGHT_PROVIDER_BY_ID(id));
  }
}

export const freightProviderService = new FreightProviderService();
